var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/LoginPopup/LoginPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/LoginPopup/LoginPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/LoginPopup/LoginPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupClasses"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupClasses(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "BasePopup--transparentLeft";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"LoginPopup\">\n        <div class=\"LoginPopup-content\">\n            <div class=\"LoginPopup-contentWrapper\" data-state=\"";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"state") == "reset"?"reset":"login"), env.opts.autoescape);
output += "\">\n\n                <div class=\"LoginPopup-block LoginPopup--login\">\n                    <h2 class=\"LoginPopup-blockTitle\">Welcome<br> to My ADG</h2>\n\n                    <form>\n                        <div class=\"LoginPopup-blockInput\">\n                            <label for=\"LoginPopup-f1\">E-mail</label>\n                            <div class=\"LoginPopup-blockInputWrapper\">\n                                <input type=\"email\" name=\"email\" id=\"LoginPopup-f1\" value=\"\">\n                            </div>\n                        </div>\n\n                        <div class=\"LoginPopup-blockInput\">\n                            <label for=\"LoginPopup-f2\">Password</label>\n                            <div class=\"LoginPopup-blockInputWrapper\">\n                                <input type=\"password\" name=\"password\" id=\"LoginPopup-f2\" value=\"\">\n                            </div>\n                        </div>\n\n                    </form>\n\n                    <button class=\"LoginPopup-blockSubmit\">Log In</button>\n\n                    <div class=\"LoginPopup-blockForgot\"><span>Forgot Your Password?</span></div>\n                </div>\n\n\n                <div class=\"LoginPopup-block LoginPopup--forgot\">\n                    <h2 class=\"LoginPopup-blockTitle\">Forgot Your<br> Password?</h2>\n\n                    <div class=\"LoginPopup-blockAnnotation\">Please enter your e-mail and we will send you a link where you will be able to set a new password. Please keep in mind that it should be the e-mail associated with your ADG account.</div>\n\n                    <form>\n                        <div class=\"LoginPopup-blockInput\">\n                            <label for=\"LoginPopup-f3\">E-mail</label>\n                            <div class=\"LoginPopup-blockInputWrapper\">\n                                <input type=\"text\" name=\"email\" id=\"LoginPopup-f3\" value=\"\">\n                            </div>\n                        </div>\n                    </form>\n\n                    <button class=\"LoginPopup-blockSubmit\">Recover</button>\n                </div>\n\n\n                <div class=\"LoginPopup-block LoginPopup--forgot-sended\">\n                    <h2 class=\"LoginPopup-blockTitle\">Forgot Your<br> Password?</h2>\n\n                    <div class=\"LoginPopup-blockThanks\">E-mail has been sent to <span></span>!</div>\n                </div>\n\n\n                <div class=\"LoginPopup-block LoginPopup--reset\">\n                    <h2 class=\"LoginPopup-blockTitle\">Reset Password<br>&nbsp;</h2>\n\n                    <form>\n                        <div class=\"LoginPopup-blockInput\">\n                            <label for=\"LoginPopup-f4\">New Password</label>\n                            <div class=\"LoginPopup-blockInputWrapper\">\n                                <input type=\"password\" name=\"password\" id=\"LoginPopup-f4\" value=\"\">\n                            </div>\n                        </div>\n\n                        <div class=\"LoginPopup-blockInput\">\n                            <label for=\"LoginPopup-f5\">Confirm New Password</label>\n                            <div class=\"LoginPopup-blockInputWrapper\">\n                                <input type=\"password\" name=\"password-confirm\" id=\"LoginPopup-f5\" value=\"\">\n                            </div>\n                        </div>\n\n                        <input type=\"hidden\" name=\"code\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"code"), env.opts.autoescape);
output += "\">\n                    </form>\n\n                    <button class=\"LoginPopup-blockSubmit\">Save</button>\n                </div>\n            </div>\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupClasses: b_popupClasses,
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/LoginPopup/LoginPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/LoginPopup/LoginPopup.jinja
// module id = 536
// module chunks = 0